import { __ENV__ } from 'awsApi'
import { ENVIRONMENTS_PREFIX, SERVICES } from '@wellbeingxltd/fe-lib/api/endpoints'
const PREFIX = ENVIRONMENTS_PREFIX[__ENV__]
export const URL = {
    ANALYTICS: {
        BASE: SERVICES.ANALYTICS[__ENV__],
        V3_ANALYTICS_SUPPLIER_CREATE: PREFIX + '/v3/analytics/supplier/create',
    },
    DIRECTORY: {
        BASE: SERVICES.DIRECTORY[__ENV__],
        V3_DIRECTORY_SHOPIFY_RESOURCE_MAPPING: PREFIX + '/v3/directory/shopify/resourceMapping',
        V3_DIRECTORY_SUPPLIER_UPDATE: PREFIX + '/v3/directory/supplier/update',
    },
    EMAIL_SUPPORT: {
        BASE: SERVICES.EMAIL_SUPPORT[__ENV__],
        V2_EMAILSUPPORT_USER_CLOSETICKET: PREFIX + '/v2/emailsupport/user/closeticket',
        V2_EMAILSUPPORT_USER_GETTRANSACTIONS: PREFIX + '/v2/emailsupport/user/gettransactions',
        V2_EMAILSUPPORT_USER_OPENTICKET: PREFIX + '/v2/emailsupport/user/openticket',
    },
    FINANCE: {
        BASE: SERVICES.FINANCE[__ENV__],
        V3_FINANCE_INVOICES_SUPPLIER_RETRIEVE: PREFIX + '/v3/finance/invoices/supplier/retrieve',
    },
    SUPPLIERS: {
        BASE: SERVICES.SUPPLIERS[__ENV__],
        V3_SUPPLIERS_DETAILS: PREFIX + '/v3/suppliers/details',
        V3_SUPPLIERS_ENABLE_DISABLE_SUPPLIER_ROLES: PREFIX + '/v3/suppliers/enable-disable-supplier-roles',
        V3_SUPPLIERS_ENABLE_DISABLE_SUPPLIER_USER: PREFIX + '/v3/suppliers/enable-disable-supplier-user',
        V3_SUPPLIERS_GET_SUPPLIER_USER: PREFIX + '/v3/suppliers/get-supplier-user',
        V3_SUPPLIERS_INVITE_SUPPLIER_USER: PREFIX + '/v3/suppliers/invite-supplier-user',
        V3_SUPPLIERS_SHOPIFY_ACCOUNT: PREFIX + '/v3/suppliers/shopify/account',
        V3_SUPPLIERS_SHOPIFY_ACCOUNT_INTEGRATE: PREFIX + '/v3/suppliers/shopify/account/integrate',
        V3_SUPPLIERS_SHOPIFY_ACCOUNT_REMOVE: PREFIX + '/v3/suppliers/shopify/account/remove',
        V3_SUPPLIERS_SHOPIFY_PRODUCTS_RETRIEVE_ALL: PREFIX + '/v3/suppliers/shopify/products/retrieveAll',
        V3_SUPPLIERS_SUPPLIER_CANCEL_TRANSACTION: PREFIX + '/v3/suppliers/supplier/cancelTransaction',
        V3_SUPPLIERS_SUPPLIER_REGENERATE_SUPPLIER_ACCOUNT_ID: PREFIX + '/v3/suppliers/supplier/regenerateSupplierAccountId',
        V3_SUPPLIERS_SUPPLIER_RESET_ATTRIBUTES: PREFIX + '/v3/suppliers/supplier/resetAttributes',
    },
    VOUCHERS: {
        BASE: SERVICES.VOUCHERS[__ENV__],
        V3_VOUCHERS_SUPPLIER: PREFIX + '/v3/vouchers/supplier',
        V4_VOUCHERS_SUPPLIER: PREFIX + '/v4/vouchers/supplier',
    },
}
